module.exports = __webpack_public_path__ + "static/img/fish41.d65e19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish41.png
// module id = g2xT
// module chunks = 0